import { Text } from '@lmc/ui-kit/src/general'
import styled from 'styled-components'
import type { PayReportRow } from '../types/payReport'

type Translate = (key: string, options?: Record<string, unknown>) => string

type AbsencePopoverBodyProps = {
  record: PayReportRow
  t: Translate
}

export const AbsencePopoverBody = ({ record, t }: AbsencePopoverBodyProps) => {
  const rows = record.absenceDaysByType?.filter((x) => x.absenceType)
  if (rows?.length) {
    return (
      <AbsenceTable>
        <tbody>
          {rows.map((item) => (
            <tr key={`${item.absenceType}-${item.days}`}>
              <td>
                <AbsenceTypeCell>{item.absenceType}</AbsenceTypeCell>
              </td>
              <td>
                <AbsenceDaysCell>
                  {t('PAY_REPORT_ABSENCE_DAYS', { count: item.days })}
                </AbsenceDaysCell>
              </td>
            </tr>
          ))}
        </tbody>
      </AbsenceTable>
    )
  }
  return (
    <EmptyWrap>
      <Text level={2}>{t('PAY_REPORT_ABSENCE_EMPTY')}</Text>
    </EmptyWrap>
  )
}

const AbsenceTable = styled.table`
  border-collapse: collapse;
  min-width: 256px;
  max-width: 320px;

  td {
    padding: 10px 12px;
    border: 1px solid ${({ theme }) => theme.color.neutral.color8};
    vertical-align: top;
  }

  td:first-child {
    background: ${({ theme }) => theme.color.neutral.color10};
  }
`

const AbsenceTypeCell = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color5};
`

const AbsenceDaysCell = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color3};
  white-space: nowrap;
`

const EmptyWrap = styled.div`
  max-width: 280px;
  padding: 4px 0;
`
